import { Action } from '@ngrx/store';
import {
  DashboardAlertDevicesInterface,
  DashboardDeviceCRUDInterface,
  DashboardDeviceInterface,
  DashboardKpiInterface,
  DashboardListInterface,
} from '../../view/device-dashboard/device-dashboard.model';
import { GeneralApiResponseInterface } from '../../layout/main/main.model';


export enum DeviceDashboardActionTypes {
  LoadLists = '[Device Dashboard] Load Lists',
  LoadListsSuccess = '[Device Dashboard] Load Lists Success',

  CreateList = '[Device Dashboard] Create List',
  CreateListSuccess = '[Device Dashboard] Create List Success',

  DeleteList = '[Device Dashboard] Delete List',
  DeleteListSuccess = '[Device Dashboard] Delete List Success',

  LoadDevices = '[Device Dashboard] Load Devices',
  LoadDevicesSuccess = '[Device Dashboard] Load Devices Success',

  UpdateDevice = '[Device Dashboard] Update Device',
  UpdateDeviceSuccess = '[Device Dashboard] Update Device Success',

  UpdateBulkDevices = '[Device Dashboard] Update Bulk Devices',
  UpdateBulkDevicesSuccess = '[Device Dashboard] Update Bulk Devices Success',

  DeleteBulkDevices = '[Device Dashboard] Delete Bulk Devices',
  DeleteBulkDevicesSuccess = '[Device Dashboard] Delete Bulk Devices Success',

  LoadAlertCounts = '[Device Dashboard] Load Alert Counts',
  LoadAlertCountsSuccess = '[Device Dashboard] Load Alert Counts Success',

  LoadAlertDevices = '[Device Dashboard] Load Alert Devices',
  LoadAlertDevicesSuccess = '[Device Dashboard] Load Alert Devices Success',

  ChangeAlertStatus = '[Device Dashboard] Change Alert Status',
  ChangeAlertStatusSuccess = '[Device Dashboard] Change Alert Status Success',

  UpdateList = '[Device Dashboard] Update List',
  UpdateListSuccess = '[Device Dashboard] Update List Success',

  SearchAllDevices = '[Device Dashboard] Search All Devices',
  SearchAllDevicesSuccess = '[Device Dashboard] Search All Devices Success',

  GenerateSharedLink = '[Device Dashboard] Generate Shared Link',
  GenerateSharedLinkSuccess = '[Device Dashboard] Generate Shared Link Success',

  FetchError = '[Device Dashboard] Fetch Error',
}

// Lists
export class LoadLists implements Action {
  readonly type = DeviceDashboardActionTypes.LoadLists;
}
export class LoadListsSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.LoadListsSuccess;
  constructor(public payload: DashboardListInterface[]) {}
}

export class CreateList implements Action {
  readonly type = DeviceDashboardActionTypes.CreateList;
  constructor(public payload: { name: string }) {}
}
export class CreateListSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.CreateListSuccess;
  constructor(public payload: DashboardListInterface) {}
}

export class DeleteList implements Action {
  readonly type = DeviceDashboardActionTypes.DeleteList;
  constructor(public id: number) {}
}
export class DeleteListSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.DeleteListSuccess;
}

// Hexbox Devices
export class LoadDevices implements Action {
  readonly type = DeviceDashboardActionTypes.LoadDevices;
  constructor(public listId: number) {}
}
export class LoadDevicesSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.LoadDevicesSuccess;
  constructor(public payload: DashboardDeviceInterface[]) {}
}

export class UpdateDevice implements Action {
  readonly type = DeviceDashboardActionTypes.UpdateDevice;
  constructor(public id: number, public payload: Partial<DashboardDeviceCRUDInterface>) {}
}
export class UpdateDeviceSuccess implements Action {
  constructor(public response: GeneralApiResponseInterface<DashboardDeviceInterface[]>) {}
  readonly type = DeviceDashboardActionTypes.UpdateDeviceSuccess;
}

export class UpdateBulkDevices implements Action {
  readonly type = DeviceDashboardActionTypes.UpdateBulkDevices;
  constructor(public listId: number, public payload: DashboardDeviceInterface[]) {}
}
export class UpdateBulkDevicesSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.UpdateBulkDevicesSuccess;
}

export class DeleteBulkDevices implements Action {
  readonly type = DeviceDashboardActionTypes.DeleteBulkDevices;
  constructor(public listId: number, public payload: number[]) {}
}
export class DeleteBulkDevicesSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.DeleteBulkDevicesSuccess;
}

// Alerts & KPIs
export class LoadAlertCounts implements Action {
  readonly type = DeviceDashboardActionTypes.LoadAlertCounts;
}
export class LoadAlertCountsSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.LoadAlertCountsSuccess;
  constructor(public payload: DashboardKpiInterface) {}
}

export class LoadAlertDevices implements Action {
  readonly type = DeviceDashboardActionTypes.LoadAlertDevices;
  constructor(public status: string | number) {} // e.g., '1' for Active, '-1' for Disabled
}
export class LoadAlertDevicesSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.LoadAlertDevicesSuccess;
  constructor(public payload: DashboardAlertDevicesInterface[]) {}
}

export class ChangeAlertStatus implements Action {
  readonly type = DeviceDashboardActionTypes.ChangeAlertStatus;
  constructor(public deviceIds: number[], public targetStatus: number) {} // 0=OK, 1=Active, 2=Ack, 3=Passive
}
export class ChangeAlertStatusSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.ChangeAlertStatusSuccess;
}

export class FetchError implements Action {
  readonly type = DeviceDashboardActionTypes.FetchError;
  constructor(public payload: any) {}
}

export class UpdateList implements Action {
  readonly type = DeviceDashboardActionTypes.UpdateList;
  constructor(public id: number, public payload: { name: string }) {}
}
export class UpdateListSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.UpdateListSuccess;
  // Passing back the updated list to update the store
  constructor(public payload: DashboardListInterface) {}
}

export class SearchAllDevices implements Action {
  readonly type = DeviceDashboardActionTypes.SearchAllDevices;
  constructor(public searchTerm: string) {}
}
export class SearchAllDevicesSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.SearchAllDevicesSuccess;
  // Assuming the search returns an array of hexbox-like or basic device interfaces
  constructor(public payload: any[]) {}
}

export class GenerateSharedLink implements Action {
  readonly type = DeviceDashboardActionTypes.GenerateSharedLink;
  constructor(public payload: {allLists?: boolean; listId?: number; listName?: string; expiresIn: string }) {}
}
export class GenerateSharedLinkSuccess implements Action {
  readonly type = DeviceDashboardActionTypes.GenerateSharedLinkSuccess;
  constructor(public payload: string | null) {} // The JWT token
}

export type DeviceDashboardActions =
  | LoadLists
  | LoadListsSuccess
  | CreateList
  | CreateListSuccess
  | DeleteList
  | DeleteListSuccess
  | LoadDevices
  | LoadDevicesSuccess
  | UpdateDevice
  | UpdateDeviceSuccess
  | UpdateBulkDevices
  | UpdateBulkDevicesSuccess
  | DeleteBulkDevices
  | DeleteBulkDevicesSuccess
  | LoadAlertCounts
  | LoadAlertCountsSuccess
  | LoadAlertDevices
  | LoadAlertDevicesSuccess
  | ChangeAlertStatus
  | ChangeAlertStatusSuccess
  | UpdateList
  | UpdateListSuccess
  | SearchAllDevices
  | SearchAllDevicesSuccess
  | GenerateSharedLink
  | GenerateSharedLinkSuccess
  | FetchError;
